import { render, staticRenderFns } from "./UploadFileSass.vue?vue&type=template&id=6742ba0b&scoped=true"
import script from "./UploadFileSass.vue?vue&type=script&lang=js"
export * from "./UploadFileSass.vue?vue&type=script&lang=js"
import style0 from "./UploadFileSass.vue?vue&type=style&index=0&id=6742ba0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742ba0b",
  null
  
)

export default component.exports